import React from "react";

//import Section from "components/sections/sections";
import Container from "components/sections/container";
const ImageGallery = ({ images, onClick, openModal }) => {
  return (
    <Container>
      <div className="grid gap-8 grid-cols-12 auto-rows-[300px] pt-4 w-full">
        {images.slice(0, 6).map((data, index) => {
          let colSpan = "lg:col-span-4";

          if (index === 0) {
            colSpan = "lg:col-span-6";
          } else if (index > 0 && index < 3) {
            colSpan = "lg:col-span-3";
          } else if (index >= 3 && index < 6) {
            colSpan = "lg:col-span-4";
          }

          return (
            <div
              className={`col-span-12 md:col-span-6 overflow-hidden md:row-span-1 ${colSpan} cursor-pointer`}
              key={"resource-gallery-" + index}
              onClick={() => {
                onClick(index);
                openModal(true);
              }}
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={data}
                alt={"img" + index}
                className={`w-full h-full object-cover transition-all hover:scale-110 object-center`}
              />
            </div>
          );
        })}
      </div>
    </Container>
  );
};
//{gridColumn:`${colStart}/${colEnd}`}
export default React.memo(ImageGallery);
